/* agmf-lone-backdrop.js — the picture behind a lone desktop piece.
 *
 * Dorian 2026-10-07: "on desktop we need once for all a solution for when we
 * have a end of feed having an odd number of media: If it is unique lets
 * generate a up to 2 rows lenght background around the media that is in the
 * middle. Make sure it works for every page".
 *
 * pdp-desk-3col.css decides WHICH piece is alone (the same parity selectors
 * that centre it) and draws the backdrop from --agmf-lone-bg. This file only
 * hands every product-card slide and feed card its own picture as that
 * variable, so whichever one ends up alone - after a colour deal, a dead card,
 * a resize - already carries it. Nothing is fetched: it is a picture the piece
 * is already showing (or its video's poster).
 *
 * Own file; reads the feed's markup, writes one custom property per piece.
 */
(function () {
  'use strict';
  if (window.__agmfLoneBackdrop) return;
  window.__agmfLoneBackdrop = true;

  var PIECES = '.agdesk-media .agmf-hero-slide, .agdesk-media .agmf-cycle > .agmf-card';
  // the content picture, never the author's avatar or a reaction icon
  var PICTURE = 'img.agmf-image, .agmf-media img, img.agmf-ytposter, img.agmf-review-img, ' +
                ':scope > img, img:not(.agmf-avatar):not([class*="avatar"])';

  function pictureOf(el) {
    var img = el.querySelector(PICTURE);
    var src = img && (img.currentSrc || img.getAttribute('src'));
    if (src) return src;
    var v = el.querySelector('video[poster]');
    return v ? v.getAttribute('poster') : '';
  }

  function stamp(el) {
    var src = pictureOf(el);
    if (!src || el.__agmfLoneBg === src) return;
    el.__agmfLoneBg = src;
    el.style.setProperty('--agmf-lone-bg', 'url("' + String(src).replace(/["\\\n]/g, encodeURIComponent) + '")');
  }

  var timer = 0;
  function sweep() {
    timer = 0;
    if (!document.documentElement.classList.contains('agdesk-on')) return;
    Array.prototype.forEach.call(document.querySelectorAll(PIECES), stamp);
  }
  function soon() { if (!timer) timer = setTimeout(sweep, 200); }

  function start() {
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
    // a lazy picture gets its currentSrc when it loads
    document.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG') soon();
    }, true);
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
